import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ReopenClosedOrderInput } from './ReopenClosedOrderInput';
import { ReopenClosedOrderOutput } from './ReopenClosedOrderOutput';

export class ReopenClosedOrderService extends HttpServiceBase {

  handle = (input: ReopenClosedOrderInput): Promise<Result<ReopenClosedOrderOutput> | null> => {
    const promise = this.http.put<Result<ReopenClosedOrderOutput>, ReopenClosedOrderInput>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/reopen-closed`,
      input
    );
    return promise;
  }
}